import { getProjectStatus, projectStatusClass } from "./projectPresentation";
import React, { useContext, useEffect, useState, useRef } from "react";

import {
  FaArrowRight,
  FaEye,
  FaFlag,
  FaRegArrowAltCircleRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { billpunchbasicauth } from "../../utils/Credentials";
import {
  BASE_URL_API_TRANXT_UAT_API,
  BASE_URL_PAYNOW,
} from "../../utils/Constant";
import { GlobalContext } from "../../Context/GlobalState";
import {
  AddBillFormAdmin,
  AddBillFormHR,
  AddResourceAdminModal,
  FetchBillModalAdmin,
  FetchBillModalHR,
  ViewResourceAdminModal,
} from "../Modal";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  FormControl,
  FormLabel,
  InputGroup,
  Modal,
  Row,
  Table,
  Tooltip,
  OverlayTrigger,
  Carousel,
} from "react-bootstrap";
import "../../index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoIosAddCircle, IoIosSend, IoMdPersonAdd } from "react-icons/io";
import { useQuery } from "../../utils/useQuery";
import swal from "sweetalert";
import { twoDecimalPlaces } from "../../utils/utilFuctions";
import { CiReceipt } from "react-icons/ci";
import { FcNext, FcPrevious } from "react-icons/fc";
export const ViewExpenseTableAdmin = ({ data, getPropertyExpense }) => {
  const { password, username } = billpunchbasicauth;

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const ApproveRejectLeave = async (expId, action) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        exp_id: expId,
        approved_byhr: action === "approve" ? "P" : "R",
        approved_byadmin: action === "approve" ? "A" : "R",
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/ApproveRejectExpense`,
        requestOptions,
      );

      const responseData = await res.json();
      if (responseData.status === "0") {
        swal("Success", responseData.msg, "success");
        getPropertyExpense();
      } else {
        swal("Error", responseData.msg, "error");
        getPropertyExpense();
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const sortedData = [...data].sort(
    (a, b) => new Date(b.expense_date) - new Date(a.expense_date),
  );
  return (
    <>
      <div className=" m-0 ">
        <div className="row">
          <div className="col-12">
            <div
              className="table-responsive"
              style={{ borderRadius: ".4em", border: "1px solid lightgrey" }}
            >
              <div style={{ width: "100%", overflowX: "auto" }}>
                <table
                  className="table table-bordered m-0 p-0"
                  style={{ minWidth: "900px" }}
                >
                  <colgroup>
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "7%" }} />
                    <col style={{ width: "6%" }} />
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "3%" }} />
                    <col style={{ width: "3%" }} />
                    <col style={{ width: "6%" }} />
                    <col style={{ width: "2%" }} />
                  </colgroup>
                  <thead>
                    <tr style={{ borderBottom: "1px solid lightgrey" }}>
                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        Name
                      </th>

                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        Date
                      </th>
                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        Amount
                      </th>
                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        {" "}
                        Type/ Description
                      </th>

                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        Approve(HR)
                      </th>
                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        Approve(Admin)
                      </th>

                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        Action
                      </th>
                      <th
                        className="text-center"
                        style={{
                          color: "#0074D9",
                          background: "#fff",
                          border: "none",
                        }}
                      >
                        Receipt
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.length > 0 ? (
                      sortedData.map((item, index) => (
                        <tr
                          style={{ borderBottom: "1px solid lightgrey" }}
                          key={index}
                        >
                          <td
                            className="text-center align-middle"
                            style={{ border: "none", fontSize: ".9rem" }}
                          >
                            {item.fullname}
                          </td>

                          <td
                            className="text-center align-middle"
                            style={{ border: "none", fontSize: ".9rem" }}
                          >
                            {new Date(item.expense_date).toLocaleDateString()}
                          </td>

                          <td
                            className="text-center align-middle"
                            style={{ border: "none", fontSize: ".9rem" }}
                          >
                            {twoDecimalPlaces(item.expense_amount)}
                          </td>
                          <td
                            className="text-center align-middle"
                            style={{ border: "none", fontSize: ".9rem" }}
                          >
                            {item.expense_type}
                            <br />
                            {item.description}
                          </td>

                          <td
                            className="text-center align-middle"
                            style={{ border: "none", fontSize: ".9rem" }}
                          >
                            {item.approved_by_hr === "R" && (
                              <span
                                className=" p-1 "
                                style={{
                                  backgroundColor: "rgba(255, 46, 46, 0.1)",
                                  color: "#ff2e2e",
                                  border: "1px solid #ff2e2e",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                              >
                                Rejected
                              </span>
                            )}
                            {item.approved_by_hr === "P" && (
                              <span
                                className=" p-1 "
                                style={{
                                  backgroundColor: "rgba(255, 255, 0, 0.1)",
                                  color: " #f7b12a",
                                  border: "1px solid #f7b12a",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                              >
                                Pending
                              </span>
                            )}
                            {item.approved_by_hr === "A" && (
                              <span
                                className=" p-1 "
                                style={{
                                  backgroundColor: "rgba(43, 193, 85, 0.1)",
                                  color: "#2bc155",
                                  border: "1px solid #2bc155",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                              >
                                Approved
                              </span>
                            )}
                          </td>
                          <td
                            className="text-center align-middle"
                            style={{ border: "none" }}
                          >
                            {item.approved_by_admin === "R" && (
                              <span
                                className=" p-1 "
                                style={{
                                  backgroundColor: "rgba(255, 46, 46, 0.1)",
                                  color: "#ff2e2e",
                                  border: "1px solid #ff2e2e",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                              >
                                Rejected
                              </span>
                            )}
                            {item.approved_by_admin === "P" && (
                              <span
                                className=" p-1 "
                                style={{
                                  backgroundColor: "rgba(255, 255, 0, 0.1)",
                                  color: " #f7b12a",
                                  border: "1px solid #f7b12a",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                              >
                                Pending
                              </span>
                            )}
                            {item.approved_by_admin === "A" && (
                              <span
                                className=" p-1 "
                                style={{
                                  backgroundColor: "rgba(43, 193, 85, 0.1)",
                                  color: "#2bc155",
                                  border: "1px solid #2bc155",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                              >
                                Approved
                              </span>
                            )}
                          </td>

                          <td
                            className="text-center align-middle"
                            style={{ border: "none" }}
                          >
                            {item.approved_by_hr === "P" ||
                            item.approved_by_admin === "P" ? (
                              <div className="d-flex justify-content-around align-items-center">
                                <span className="px-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-success d-flex justify-content-center align-items-center"
                                    style={{
                                      height: "1.5rem",
                                      borderRadius: ".3rem",
                                      fontSize: ".8rem",
                                    }}
                                    onClick={() =>
                                      ApproveRejectLeave(
                                        item.pk_expense_id,
                                        "approve",
                                      )
                                    }
                                  >
                                    Approve
                                  </button>
                                </span>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger d-flex justify-content-center align-items-center"
                                  style={{
                                    height: "1.5rem",
                                    borderRadius: ".3rem",
                                    fontSize: ".8rem",
                                  }}
                                  onClick={() =>
                                    ApproveRejectLeave(
                                      item.pk_expense_id,
                                      "reject",
                                    )
                                  }
                                >
                                  Reject
                                </button>
                              </div>
                            ) : (
                              <div className="d-flex justify-content-around align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-success d-flex justify-content-center align-items-center"
                                  style={{
                                    height: "1.5rem",
                                    borderRadius: ".3rem",
                                    fontSize: ".8rem",
                                    filter: "grayscale(100%)",
                                  }}
                                  disabled
                                >
                                  Approve
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger d-flex justify-content-center align-items-center"
                                  style={{
                                    height: "1.5rem",
                                    borderRadius: ".3rem",
                                    fontSize: ".8rem",
                                    filter: "grayscale(100%)",
                                  }}
                                  disabled
                                >
                                  Reject
                                </button>
                              </div>
                            )}
                          </td>
                          <td
                            className="text-center align-middle"
                            style={{ border: "none" }}
                          >
                            <a
                              href={item.baseurl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <CiReceipt style={{ fontSize: "2rem" }} />
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export const ViewvendorbillTableAdmin = ({ data, GetVendorItems }) => {
  return (
    <>
      <div className="row p-0">
        <div className="col-12">
          <div
            className="table-responsive"
            style={{ borderRadius: ".4em", border: "1px solid lightgrey" }}
          >
            <table className="table table-bordered m-0 p-0">
              <thead>
                <tr style={{ borderBottom: "1px solid lightgrey" }}>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    ID
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    Item
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    HSN
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    Quantity
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    Per Amount
                  </th>

                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    {" "}
                    CGST (%) <br />
                    CGST Amount
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    SGST (%) <br />
                    SGST Amount
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    Transaction Type
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    Total Amount
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    Cheque
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                      fontsize: ".4rem",
                    }}
                  >
                    Bill
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <tr
                      style={{ borderBottom: "1px solid lightgrey" }}
                      key={index}
                    >
                      <td
                        className="text-center align-middle"
                        style={{ border: "none" }}
                      >
                        {index + 1}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        {item.item}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        {item.hsn_code}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        {item.qty}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        ₹{twoDecimalPlaces(item.perAmount)}
                      </td>

                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        {" "}
                        {item.cgst_percent
                          ? `${parseFloat(item.sgst_percent)}%`
                          : "0%"}
                        <br />₹{twoDecimalPlaces(item.cgst_amount)}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        {" "}
                        {item.sgst_percent
                          ? `${parseFloat(item.sgst_percent)}%`
                          : "0%"}
                        <br />₹{twoDecimalPlaces(item.sgst_amount)}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        {item.trans_type}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        ₹{twoDecimalPlaces(item.totalAmount)}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        <a
                          href={item.cheque_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <CiReceipt style={{ fontSize: "2rem" }} />
                        </a>
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", fontsize: ".8rem" }}
                      >
                        <a
                          href={item.bill_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <CiReceipt style={{ fontSize: "2rem" }} />
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
export const ReviewBillTableAdmin = ({}) => {
  const [fetchBillModal, setFetchBillModal] = useState(false);
  const [amount, setAmount] = useState("");
  const { Profileinfo } = useContext(GlobalContext);
  const query = useQuery();
  const id = query.get("id");
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedItem, setSelectedItem] = useState(null);
  const [billerResponse, setBillerResponse] = useState({});
  const [state, setState] = useState({});
  const [fetchButtonDisable, setFetchButtonDisable] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [billPayResponse, setBillPayResponse] = useState(null);
  const [fetchButtonText, setFetchButtonText] = useState("Fetch bill");
  const [username, setUsername] = useState("Rajneesh@example.com");
  const [password, setPassword] = useState("Test@12345");
  const CustP = sessionStorage.getItem("params")
    ? JSON.parse(sessionStorage.getItem("params"))
    : [];

  const [selectedItems, setSelectedItems] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState({});

  const [showFetchModal, setShowFetchModal] = useState(false);
  const [formValues, setFormValues] = useState({
    fromDate: "",
    toDate: "",
    category: "",
    amount: "",
    minAmount: "",
    maxAmount: "",
    dateOption: "All Dates",
  });
  const handleShowFetchModal = (item) => {
    setSelectedItem(item);
    setShowFetchModal(true);
  };

  const handleCloseFetchModal = () => {
    setShowFetchModal(false);
  };
  const fetchBill = async (biller, custParams, item) => {
    // console.log("hua kuch");
    setBillerResponse({ msg: "", success: "", error: [] });
    setTransactionLoaderState(true);
    // const biller = state.provider;
    // if (biller.length == 0) {
    //   return;
    // }
    setFetchButtonDisable(true);
    setBillDetails(null);
    setBillPayResponse(null);
    setFetchButtonText("Fetching bill ...");
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username + ":" + password).toString("base64"),
    );
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Cookie",
      ".AspNetCore.Identity.Application=CfDJ8PA2Dduz6XVGpbQn-N2Kqq5gCNuTSX1hZVmzSqRADx47lqe6bGFocHiTHywahzfmyy_hxGzt34-c9e73A_uQhz1K_y2TKvnqIc0lLSVxenEuk9l6kzurFY1os90YhONj1qkI2AbuInUzp0l4WuKcQVbg1geMa3e35cjnGSbkRMMjfCOf7VdYuQT1xp3H4r8QBXN6CYFJLFlHp7aL0YZR-JJ3TSxrfTn-54gPPl852sLVcjFIeMOdXJTu1vpSHK9FdV93vouzmDtYSILdUCqjJ4rZ-rw-c-5Jt6wlqfj81tjbjRGTnDxMqa1y9PF8SeKzHFVmwvvB86NCfk6X12kl0Z6DwaVY2mnoalgrYPP3oEu4jZIK-QA3BE_g15RP6qDxa4g6ePtn_Bn46hjTaY6a-MN_0uydHiJ51ehGQ5eX9sFEV--g-KOo5ty5EUGD2SjX5t5zPBnPLiwOx0q2aFMu5ww8BC7u3OmsIYYHNq59zIG8plliQCkkxPaL9NX3MdnHwvziP5uQUTS0NnRynMsz86khYMnSiA1y9KL1zQKkvxQQKLp-V8F7hoAfn7K_r0yoNpHECXMkLjAv1c_9LsAzc0FNmvY9fOGtwIBIzZE2Cg1ZPB9m6IgADqBv5mUEKAfENApiWviasg1BPjtOIIJgcUdr4lpxMofSD9_b0-qJNv",
    );
    const base64Credentials = btoa(`${username}:${password}`);

    console.log(biller);
    let params = [];
    custParams.forEach((param) => {
      if (param.value && param.value != "") {
        params.push({
          name: param.paramName,
          value: param.value,
        });
      }
    });
    console.log(params);

    var raw = JSON.stringify({
      customerMobileNo: "9971407960",
      billDetails: {
        billerId: biller,
        customerParams: params,
      },
    });

    console.log(raw);

    var requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/json",
      },
      body: raw,
      redirect: "follow",
    };
    try {
      // console.log("hua");
      const res = await fetch(
        `${BASE_URL_PAYNOW}/api/Biller/BillFetch`,
        requestOptions,
      );
      const data = await res.json();

      if (data.status == "FAILURE") {
        swal("FAILURE", data.response.complianceReason, "error");
        // updatePropertyBill(item);
      } else {
        swal("Success", "Successfull", "success");
        // updatePropertyBill(item);
      }
      console.log(
        "Before updatePropertyBill call" + data.response.billerResponse,
      );
      //  updatePropertyBill(data.response,data1);

      console.log("After updatePropertyBill call");
      if (
        data.respCode == "1" &&
        data.response &&
        data.response.billerResponse &&
        data.response.billerResponse.customerName &&
        data.response.billerResponse.customerName != ""
      ) {
        setBillerResponse({
          ...billerResponse,
          error: [],
          msg: "",
        });
        setFetchBillModal(true);
        setBillDetails(data.response);
        setAmount(data.response.billerResponse.amount);
      } else if (
        data.respCode == "0" &&
        data.response &&
        data.response.errorList &&
        data.response.errorList.length > 0
      ) {
        setBillerResponse({
          ...billerResponse,
          error: data.response.errorList,
          msg: "",
        });
      } else {
        setBillerResponse({
          ...billerResponse,
          error: [],
          msg: "Something went wrong",
        });
      }
      setTransactionLoaderState(false);
      setFetchButtonDisable(false);
      setFetchButtonText("Fetch bill");
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
      setFetchButtonDisable(false);
      setFetchButtonText("Fetch bill");
    }
  };

  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const getAllPropertyBills = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        id: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getfirmBills`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        console.log(data.data);
        setData(data.data);
        setData1(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const updatePropertyBill = async (item, data12) => {
    console.log(data1 + "123");
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        b_id: data12.id,
        firmid: user.firm_id,
        service: data12.service,
        provider: data12.provider,
        consumerid: data12.consumerid,
        mobile: Profileinfo?.mobile,
        month: item.billerResponse.billDate,
        amount: item.billerResponse.amount,
        refno: item.refId,
        paramslist: JSON.stringify(data12.paramsList),
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/updateSalaryBill`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        getAllPropertyBills();
      }
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };

  useEffect(() => {
    getAllPropertyBills();
  }, [id]);

  const handleItemSelection = (item) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((selectedItem) => selectedItem !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };
  return (
    <>
      <FetchBillModalAdmin
        fetchBillModal={fetchBillModal}
        setFetchBillModal={setFetchBillModal}
        billDetails={billDetails}
        billerResponse={billerResponse}
        callback={() => {}}
        billPayResponse={billPayResponse}
        setAmount={() => {}}
        amount={amount}
        setTpin={() => {}}
        Tpin={"0"}
        config={{ amountEditable: false }}
      />
      <AddBillFormAdmin
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        getAllPropertyBills={getAllPropertyBills}
      />
      <div className="row d-flex justify-content-between align-items-center mx-2">
        <div className="col-auto">
          <h4 className="mb-0">Bills</h4>
        </div>

        <div className="col-auto">
          <button
            type="button"
            className="btn btn-sm d-flex justify-content-center align-items-center"
            style={{
              background: "#2ca01c",
              borderRadius: ".4em",
              height: "2rem",
              width: "7rem",
              border: "none",
              color: "#fff",
            }}
            onClick={handleShowModal}
          >
            Add Biller
          </button>
        </div>
      </div>

      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "30px" }}
      >
        <table
          className="PMS-collection-table m-1"
          style={{
            textAlign: "center",
            overflow: "hidden",
            borderRadius: ".4rem",
          }}
        >
          <thead>
            <tr>
              <th style={{ color: "#0074D9" }}>Services</th>
              <th style={{ color: "#0074D9" }}>Provider</th>
              <th style={{ color: "#0074D9" }}>Bill Date</th>
              <th style={{ color: "#0074D9" }}> Consumer ID </th>
              <th style={{ color: "#0074D9" }}>Amount</th>
              <th
                style={{
                  color: "#0074D9",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td>{item.service}</td>
                  <td>{item.provider}</td>
                  <td>{new Date(item.month).toLocaleDateString()}</td>
                  <td>{item.consumerid}</td>
                  <td>{twoDecimalPlaces(item.amount)}</td>
                  <td className="d-flex justify-content-center">
                    <div style={{ marginRight: "10px" }}>
                      <Badge
                        type="button"
                        className="btn btn-sm"
                        style={{
                          background: "white",
                          color: "#0074D9",
                          border: "1px solid #0074D9",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={() => {
                          console.log("ni hua");
                          fetchBill(item.provider, item.paramsList);
                        }}
                      >
                        Fetch & Pay
                      </Badge>
                    </div>
                    <div style={{ marginRight: "10px" }}>
                      <Badge
                        type="button"
                        className="btn btn-sm"
                        style={{
                          background: "white",
                          color: "#0074D9",
                          border: "1px solid #0074D9",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={() => {
                          updatePropertyBill(billDetails, item);
                        }}
                      >
                        Update
                      </Badge>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export const ViewProjectadmindash = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);

  const { password, username } = billpunchbasicauth;
  const [projectdata, setprojectdata] = useState([]);
  const getProjects = async (e) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        created_by: "Admin",
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmProjects`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status == "0") {
        setprojectdata(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  useEffect(() => {
    getProjects();
  }, []);
  return (
    <>
      <div className="row">
        <h6 className="col">Project</h6>
        <div className="col d-flex justify-content-end">
          <Link to="/admin/Createproject">
            <p className="px-1">
              View More <FaRegArrowAltCircleRight />
            </p>
          </Link>
        </div>
      </div>
      <table
        className="table table-bordered m-0 p-0 "
        style={{ border: "none" }}
      >
        <thead
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            background: "#fff",
          }}
        >
          <tr style={{ borderBottom: "1px solid lightgrey" }}>
            <th
              className="text-center"
              style={{
                color: "#0074D9",
                background: "#fff",
                border: "none",
              }}
            >
              Name
            </th>

            <th
              className="text-center"
              style={{
                color: "#0074D9",
                background: "#fff",
                border: "none",
              }}
            >
              Ownership
            </th>

            <th
              className="text-center"
              style={{
                color: "#0074D9",
                background: "#fff",
                border: "none",
              }}
            >
              Progress
            </th>
          </tr>
        </thead>
        <tbody>
          {projectdata.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">
                No data available
              </td>
            </tr>
          ) : (
            projectdata.slice(0, 3).map((item, index) => (
              <tr style={{ borderBottom: "1px solid lightgrey" }} key={index}>
                <td
                  className="text-center align-middle"
                  style={{
                    border: "none",
                    filter: index === 2 ? "blur(2px)" : "none",
                    background: "#fff",
                    fontSize: ".9rem",
                    fontWeight: "400",
                  }}
                >
                  {item.project_name || "NA"}
                </td>
                <td
                  className="text-center align-middle"
                  style={{
                    border: "none",
                    filter: index === 2 ? "blur(2px)" : "none",
                    background: "#fff",
                    fontSize: ".9rem",
                    fontWeight: "400",
                  }}
                >
                  {item.project_ownership || "NA"}
                </td>
                <td
                  className="text-center align-middle"
                  style={{
                    border: "none",
                    filter: index === 2 ? "blur(2px)" : "none",
                    background: "#fff",
                    fontSize: ".9rem",
                    fontWeight: "400",
                  }}
                >
                  <progress
                    value={item.progress}
                    max="100"
                    style={{ width: "100px" }}
                  >
                    {item.progress}%
                  </progress>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </>
  );
};
export const ViewProjectadmin = ({ data, getProjects, searchTerm }) => {
  const [showviewresourceModal, setshowviewresourceModal] = useState(false);
  const [showaddresourceModal, setshowaddresourceModal] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const openaddresourceModal = (pk_project_id) => {
    setshowaddresourceModal(true);
    setProjectId(pk_project_id);
  };

  const closeaddresourceModal = () => {
    setshowaddresourceModal(false);
  };
  const openviewresourceModal = (pk_project_id) => {
    setProjectId(pk_project_id);
    setshowviewresourceModal(true);
  };

  const closeviewresourceModal = () => {
    setshowviewresourceModal(false);
  };
  const [pageSize, setPageSize] = useState(30);
  const [page, setPage] = useState(1);
  const filteredData = data.filter((item) =>
    `${item.project_name || ""} ${item.project_description || item.project_discription || ""}`
      .toLowerCase()
      .includes((searchTerm || "").toLowerCase()),
  );
  const pageCount = Math.max(1, Math.ceil(filteredData.length / pageSize));
  const visiblePage = Math.min(page, pageCount);
  const pageData = filteredData.slice(
    (visiblePage - 1) * pageSize,
    visiblePage * pageSize,
  );
  const handleProjectRequirementsClick = (projectId, projectname) => {
    sessionStorage.setItem("selectedProjectId", projectId);
    sessionStorage.setItem("selectedProjectname", projectname);
  };
  return (
    <>
      <ViewResourceAdminModal
        show={showviewresourceModal}
        closeModal={closeviewresourceModal}
        projectId={projectId}
      />
      <AddResourceAdminModal
        show={showaddresourceModal}
        closeModal={closeaddresourceModal}
        getProjects={getProjects}
        projectId={projectId}
      />
      <div className="projects-list-heading">
        <h2>
          <span className="projects-list-symbol">◆</span> All Projects{" "}
          <span>({filteredData.length})</span>
        </h2>
        <label>
          Show{" "}
          <select
            aria-label="Projects per page"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >
            {[30, 50, 100, 500].map((size) => (
              <option key={size}>{size}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="projects-table-scroll">
        <table className="projects-table">
          <thead>
            <tr>
              {[
                // "ID",
                "Project Name",
                "Description",
                "Start Date",
                "End Date",
                "Ownership",
                "Status",
                "Action",
              ].map((label) => (
                <th key={label}>{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pageData.map((item, index) => {
              const status = getProjectStatus(item);
              const owner = item.project_ownership || "Unassigned";
              const displayDate = (value) => {
                const date = value ? new Date(value) : null;
                return date && !Number.isNaN(date.getTime())
                  ? date.toLocaleDateString("en-GB")
                  : "—";
              };
              return (
                <tr key={item.pk_project_id || index}>
                  {/* <td>{(visiblePage - 1) * pageSize + index + 1}</td> */}
                  <td>
                    <strong>{item.project_name || "—"}</strong>
                  </td>
                  <td
                    className="projects-description"
                    title={item.project_description || item.project_discription}
                  >
                    {item.project_description ||
                      item.project_discription ||
                      "—"}
                  </td>
                  <td>{displayDate(item.project_startdate)}</td>
                  <td>{displayDate(item.project_enddate)}</td>
                  <td>
                    <div className="projects-owner">
                      <span>
                        {owner
                          .split(/\s+/)
                          .filter(Boolean)
                          .slice(0, 2)
                          .map((name) => name[0])
                          .join("")}
                      </span>
                      <strong title={owner}>{owner}</strong>
                    </div>
                  </td>
                  <td>
                    <span
                      className={`projects-status ${projectStatusClass(status)}`}
                    >
                      <i />
                      {status}
                    </span>
                  </td>
                  <td className="projects-actions">
                    {" "}
                    <div className="d-flex justify-content-center align-items-center">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-add-employee">
                            Add Resource
                          </Tooltip>
                        }
                      >
                        <IoIosAddCircle
                          style={{
                            fontSize: "1.3rem",
                            marginRight: "10px",
                            color: "#37AFE1",
                          }}
                          onClick={() =>
                            openaddresourceModal(item.pk_project_id)
                          }
                        />
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-view-employee">
                            View Resources
                          </Tooltip>
                        }
                      >
                        <FaEye
                          style={{
                            fontSize: "1.3rem",
                            marginRight: "10px",
                            color: "#37AFE1",
                          }}
                          onClick={() =>
                            openviewresourceModal(item.pk_project_id)
                          }
                        />
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-other-icon">
                            Add Requirements
                          </Tooltip>
                        }
                      >
                        <Link
                          to="/admin/Project_Requirements"
                          onClick={() =>
                            handleProjectRequirementsClick(
                              item.pk_project_id,
                              item.project_name,
                            )
                          }
                        >
                          <FaArrowRight
                            style={{
                              fontSize: "1.2rem",
                              marginRight: "10px",
                              color: "#37AFE1",
                            }}
                          />
                        </Link>
                      </OverlayTrigger>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!filteredData.length && (
          <div className="projects-empty">
            No projects match the selected filters.
          </div>
        )}
      </div>
      <footer className="projects-pagination">
        <span>
          {filteredData.length ? (visiblePage - 1) * pageSize + 1 : 0}–
          {Math.min(visiblePage * pageSize, filteredData.length)} of{" "}
          {filteredData.length} projects
        </span>
        <div>
          <button
            disabled={visiblePage <= 1}
            onClick={() => setPage(visiblePage - 1)}
          >
            Previous
          </button>
          <button
            disabled={visiblePage >= pageCount}
            onClick={() => setPage(visiblePage + 1)}
          >
            Next
          </button>
        </div>
      </footer>
    </>
  );
};
export const ViewProjectrequirementadmin = ({ data, searchTerm }) => {
  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  return (
    <>
      <div className="m-0">
        <div className="row">
          <div className="col-12">
            <div
              className="table-responsive"
              style={{ borderRadius: ".4em", border: "1px solid lightgrey" }}
            >
              <table className="table table-bordered m-0 p-0">
                <thead>
                  <tr style={{ borderBottom: "1px solid lightgrey" }}>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      ID
                    </th>

                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Name
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Category
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Cost
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Hours
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Resource Count
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr>
                      <td
                        colSpan="6"
                        className="text-center"
                        style={{ padding: "8px" }}
                      >
                        No data found
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((item, index) => (
                      <tr
                        style={{ borderBottom: "1px solid lightgrey" }}
                        key={index}
                      >
                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          {item.projectid || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          {item.name || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          {item.category || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          {item.cost || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          {item.hours || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          {item.res_count || "NA"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export const SubTasklistAdmin = () => {
  const taskdetails = JSON.parse(sessionStorage.getItem("taskdetails"));
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;

  const [taskdata, setTaskData] = useState([]);
  const getTask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        taskid: taskdetails.pk_taskid,
        platformid: "1",
        categoryid: "1",
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetSubTask`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setTaskData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getTask();
  }, []);

  return (
    <div>
      {taskdata.length === 0 ? (
        <div className="d-flex justify-content-center">
          <h6>No data found</h6>
        </div>
      ) : (
        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
            tableLayout: "fixed",
          }}
        >
          <thead
            style={{
              position: "sticky",
              top: 0,
              background: "#fff",
            }}
          >
            <tr>
              <th style={headerStyle}>Task Name</th>
              <th style={headerStyle}>Assignee</th>
              <th style={{ ...headerStyle, textAlign: "center" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {taskdata.slice(0, 5).map((item, index) => (
              <tr key={item.pk_task_id}>
                <td style={cellStyle(index)}>{/* Task name + flag */}</td>
                <td style={cellStyle(index)}>{item.sub_empname}</td>
                <td style={{ ...cellStyle(index), textAlign: "center" }}>
                  {/* Status tag */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="d-flex justify-content-center mt-2">
        <Link to="/admin/Subtasks">
          <FcPrevious />
          View More
          <FcNext />
        </Link>
      </div>
    </div>
  );
};
const headerStyle = {
  borderBottom: "1px solid #f2f4f2",
  color: "#000",
  padding: "8px",
  textAlign: "left",
  background: "#fff",
};

const cellStyle = {
  border: "none",
  fontSize: ".9rem",
  fontWeight: "400",
};
export const ViewBalanceleave = ({ data, Getbalanceleave }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editableData, setEditableData] = useState({});
  const { setTransactionLoaderState } = useContext(GlobalContext);

  const { password, username } = billpunchbasicauth;
  const handleEdit = (rowData) => {
    setSelectedRow(rowData);
    setEditableData({ ...rowData });
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedRow(null);
    setEditableData({});
  };

  const handleChange = (key, value) => {
    setEditableData((prev) => ({ ...prev, [key]: value }));
  };

  const cellStyle = {
    padding: "8px",
    border: "none",
    fontSize: "0.9rem",
  };
  const handleSave = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        id: parseInt(editableData.id),
        slBal: parseFloat(editableData.sl_bal),
        plBal: parseFloat(editableData.pl_bal),
        consumedPl: parseFloat(editableData.consumed_pl),
        consumedSl: parseFloat(editableData.consumed_sl),
        remainingSl: parseFloat(editableData.remaining_sl),
        remainingPl: parseFloat(editableData.remaining_pl),
        halfDay: parseFloat(editableData.halfday),
        actualLeave: parseFloat(editableData.actual_leave),
        month: parseInt(editableData.month),
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/UpdateLeaveBalance`,
        requestOptions,
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setTransactionLoaderState(false);
      console.log("API Response:", data);
      if (data.status === "0" && data.result?.[0]?.result === "Y") {
        swal(
          "Success",
          data.result[0].message || "Leave balance updated successfully!",
          "success",
        );
        Getbalanceleave();
        handleClose();
      } else {
        swal(
          "Error",
          data.result?.[0]?.message || "Something went wrong!",
          "error",
        );
      }
    } catch (error) {
      console.error("Error occurred:", error);
      setTransactionLoaderState(false);
      swal("Error", "An unexpected error occurred!", "error");
    }
  };
  return (
    <div className="m-0">
      <div className="row pt-0">
        <div className="col-12">
          <div
            className="table-responsive"
            style={{ borderRadius: ".4em", border: "1px solid lightgrey" }}
          >
            {data.length > 0 ? (
              <div
                style={{
                  maxHeight: "80vh",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                }}
              >
                <table className="table table-bordered m-0 p-0">
                  <thead
                    className="bg-white"
                    style={{ position: "sticky", top: 0, zIndex: 1 }}
                  >
                    <tr style={{ borderBottom: "1px solid lightgrey" }}>
                      {[
                        "Name",
                        "Total PL",
                        "Total SL",
                        "Consumed PL",
                        "Consumed SL",
                        "Remaining PL",
                        "Remaining SL",
                        "Half Day",
                        "Actual Leave",
                        "Month",
                        "Edit",
                      ].map((heading) => (
                        <th
                          key={heading}
                          className="text-center"
                          style={{
                            color: "#0074D9",
                            background: "#fff",
                            border: "none",
                            fontSize: "0.9rem",
                            fontWeight: "600",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                          }}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr
                        key={index}
                        style={{ borderBottom: "1px solid lightgrey" }}
                      >
                        <td className="align-middle" style={cellStyle}>
                          {item.fullname || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.pl_bal || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.sl_bal || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.consumed_pl || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.consumed_sl || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.remaining_pl || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.remaining_sl || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.halfday || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.actual_leave || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          {item.month || "NA"}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={cellStyle}
                        >
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleEdit(item)}
                          >
                            Edit
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center p-3">No data found</div>
            )}
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Edit Leave Record</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRow ? (
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead className="table-light">
                  <tr>
                    <th>Name</th>
                    <th>Total PL</th>
                    <th>Total SL</th>
                    <th>Consumed PL</th>
                    <th>Consumed SL</th>
                    <th>Remaining PL</th>
                    <th>Remaining SL</th>
                    <th>Half Day</th>
                    <th>Actual Leave</th>
                    <th>Month</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontSize: ".8rem" }}>
                      <p style={{ fontSize: ".8rem" }}>
                        {editableData.fullname}
                      </p>
                    </td>

                    <td>
                      <Form.Control
                        className=""
                        type="number"
                        value={editableData.pl_bal || ""}
                        onChange={(e) => handleChange("pl_bal", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={editableData.sl_bal || ""}
                        onChange={(e) => handleChange("sl_bal", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={editableData.consumed_pl || ""}
                        onChange={(e) =>
                          handleChange("consumed_pl", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={editableData.consumed_sl || ""}
                        onChange={(e) =>
                          handleChange("consumed_sl", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={editableData.remaining_pl || ""}
                        onChange={(e) =>
                          handleChange("remaining_pl", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={editableData.remaining_sl || ""}
                        onChange={(e) =>
                          handleChange("remaining_sl", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={editableData.halfday || ""}
                        onChange={(e) =>
                          handleChange("halfday", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={editableData.actual_leave || ""}
                        onChange={(e) =>
                          handleChange("actual_leave", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={editableData.month || ""}
                        onChange={(e) => handleChange("month", e.target.value)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <p>No data selected.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export const ReviewBillTableHR = ({}) => {
  const [fetchBillModal, setFetchBillModal] = useState(false);
  const [amount, setAmount] = useState("");
  const { Profileinfo } = useContext(GlobalContext);
  const query = useQuery();
  const id = query.get("id");
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedItem, setSelectedItem] = useState(null);
  const [billerResponse, setBillerResponse] = useState({});
  const [state, setState] = useState({});
  const [fetchButtonDisable, setFetchButtonDisable] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [billPayResponse, setBillPayResponse] = useState(null);
  const [fetchButtonText, setFetchButtonText] = useState("Fetch bill");
  const [username, setUsername] = useState("Rajneesh@example.com");
  const [password, setPassword] = useState("Test@12345");
  const CustP = sessionStorage.getItem("params")
    ? JSON.parse(sessionStorage.getItem("params"))
    : [];
  const [selectedItems, setSelectedItems] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState({});

  const [showFetchModal, setShowFetchModal] = useState(false);
  const [formValues, setFormValues] = useState({
    fromDate: "",
    toDate: "",
    category: "",
    amount: "",
    minAmount: "",
    maxAmount: "",
    dateOption: "All Dates",
  });
  const handleShowFetchModal = (item) => {
    setSelectedItem(item);
    setShowFetchModal(true);
  };

  const handleCloseFetchModal = () => {
    setShowFetchModal(false);
  };
  const fetchBill = async (biller, custParams, item) => {
    console.log("hua kuch");
    setBillerResponse({ msg: "", success: "", error: [] });
    setTransactionLoaderState(true);

    setFetchButtonDisable(true);
    setBillDetails(null);
    setBillPayResponse(null);
    setFetchButtonText("Fetching bill ...");
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username + ":" + password).toString("base64"),
    );
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Cookie",
      ".AspNetCore.Identity.Application=CfDJ8PA2Dduz6XVGpbQn-N2Kqq5gCNuTSX1hZVmzSqRADx47lqe6bGFocHiTHywahzfmyy_hxGzt34-c9e73A_uQhz1K_y2TKvnqIc0lLSVxenEuk9l6kzurFY1os90YhONj1qkI2AbuInUzp0l4WuKcQVbg1geMa3e35cjnGSbkRMMjfCOf7VdYuQT1xp3H4r8QBXN6CYFJLFlHp7aL0YZR-JJ3TSxrfTn-54gPPl852sLVcjFIeMOdXJTu1vpSHK9FdV93vouzmDtYSILdUCqjJ4rZ-rw-c-5Jt6wlqfj81tjbjRGTnDxMqa1y9PF8SeKzHFVmwvvB86NCfk6X12kl0Z6DwaVY2mnoalgrYPP3oEu4jZIK-QA3BE_g15RP6qDxa4g6ePtn_Bn46hjTaY6a-MN_0uydHiJ51ehGQ5eX9sFEV--g-KOo5ty5EUGD2SjX5t5zPBnPLiwOx0q2aFMu5ww8BC7u3OmsIYYHNq59zIG8plliQCkkxPaL9NX3MdnHwvziP5uQUTS0NnRynMsz86khYMnSiA1y9KL1zQKkvxQQKLp-V8F7hoAfn7K_r0yoNpHECXMkLjAv1c_9LsAzc0FNmvY9fOGtwIBIzZE2Cg1ZPB9m6IgADqBv5mUEKAfENApiWviasg1BPjtOIIJgcUdr4lpxMofSD9_b0-qJNv",
    );

    console.log(biller);
    let params = [];
    custParams.forEach((param) => {
      if (param.value && param.value != "") {
        params.push({
          name: param.paramName,
          value: param.value,
        });
      }
    });
    console.log(params);

    var raw = JSON.stringify({
      customerMobileNo: "9971407960",
      billDetails: {
        billerId: biller,
        customerParams: params,
      },
    });

    console.log(raw);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    try {
      console.log("hua");
      const res = await fetch(
        `${BASE_URL_PAYNOW}/api/Biller/BillFetch`,
        requestOptions,
      );
      const data = await res.json();

      if (data.status == "FAILURE") {
        swal("FAILURE", data.response.complianceReason, "error");
        // updatePropertyBill(item);
      } else {
        swal("Success", "Successfull", "success");
        // updatePropertyBill(item);
      }
      console.log(
        "Before updatePropertyBill call" + data.response.billerResponse,
      );
      //  updatePropertyBill(data.response,data1);

      console.log("After updatePropertyBill call");
      if (
        data.respCode == "1" &&
        data.response &&
        data.response.billerResponse &&
        data.response.billerResponse.customerName &&
        data.response.billerResponse.customerName != ""
      ) {
        setBillerResponse({
          ...billerResponse,
          error: [],
          msg: "",
        });
        setFetchBillModal(true);
        setBillDetails(data.response);
        setAmount(data.response.billerResponse.amount);
      } else if (
        data.respCode == "0" &&
        data.response &&
        data.response.errorList &&
        data.response.errorList.length > 0
      ) {
        setBillerResponse({
          ...billerResponse,
          error: data.response.errorList,
          msg: "",
        });
      } else {
        setBillerResponse({
          ...billerResponse,
          error: [],
          msg: "Something went wrong",
        });
      }
      setTransactionLoaderState(false);
      setFetchButtonDisable(false);
      setFetchButtonText("Fetch bill");
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
      setFetchButtonDisable(false);
      setFetchButtonText("Fetch bill");
    }
  };

  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const getAllPropertyBills = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        id: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getfirmBills`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        console.log(data.data);
        setData(data.data);
        setData1(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const updatePropertyBill = async (item, data12) => {
    console.log(data1 + "123");
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        b_id: data12.id,
        firmid: user.firm_id,
        service: data12.service,
        provider: data12.provider,
        consumerid: data12.consumerid,
        mobile: Profileinfo?.mobile,
        month: item.billerResponse.billDate,
        amount: item.billerResponse.amount,
        refno: item.refId,
        paramslist: JSON.stringify(data12.paramsList),
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/updateSalaryBill`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        getAllPropertyBills();
      }
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };

  useEffect(() => {
    getAllPropertyBills();
  }, [id]);

  const handleItemSelection = (item) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((selectedItem) => selectedItem !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };
  return (
    <>
      <FetchBillModalHR
        fetchBillModal={fetchBillModal}
        setFetchBillModal={setFetchBillModal}
        billDetails={billDetails}
        billerResponse={billerResponse}
        callback={() => {}}
        billPayResponse={billPayResponse}
        setAmount={() => {}}
        amount={amount}
        setTpin={() => {}}
        Tpin={"0"}
        config={{ amountEditable: false }}
      />
      <AddBillFormHR
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        getAllPropertyBills={getAllPropertyBills}
      />
      <div className="row align-items-center justify-content-between mx-2">
        <div className="col-auto">
          <h4 className="mb-0">Bills</h4>
        </div>

        <div className="col d-flex justify-content-end align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm d-flex justify-content-center align-items-center"
            style={{
              background: "#2ca01c",
              borderRadius: ".4em",
              height: "2rem",
              width: "7rem",
              border: "none",
              color: "#fff",
            }}
            onClick={handleShowModal}
          >
            Add Biller
          </button>
        </div>
      </div>

      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "30px" }}
      >
        <table
          className="PMS-collection-table m-1"
          style={{
            textAlign: "center",
            overflow: "hidden",
            borderRadius: ".4rem",
          }}
        >
          <thead>
            <tr>
              <th style={{ color: "#0074D9" }}>Services</th>
              <th style={{ color: "#0074D9" }}>Provider</th>
              <th style={{ color: "#0074D9" }}>Bill Date</th>
              <th style={{ color: "#0074D9" }}> Consumer ID </th>
              <th style={{ color: "#0074D9" }}>Amount</th>
              <th
                style={{
                  color: "#0074D9",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td>{item.service}</td>
                  <td>{item.provider}</td>
                  <td>{new Date(item.month).toLocaleDateString()}</td>
                  <td>{item.consumerid}</td>
                  <td>{twoDecimalPlaces(item.amount)}</td>
                  <td className="d-flex justify-content-center">
                    <div style={{ marginRight: "10px" }}>
                      <Badge
                        type="button"
                        className="btn btn-sm"
                        style={{
                          background: "white",
                          color: "#0074D9",
                          border: "1px solid #0074D9",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={() => {
                          console.log("ni hua");
                          fetchBill(item.provider, item.paramsList);
                        }}
                      >
                        Fetch & Pay
                      </Badge>
                    </div>
                    <div style={{ marginRight: "10px" }}>
                      <Badge
                        type="button"
                        className="btn btn-sm"
                        style={{
                          background: "white",
                          color: "#0074D9",
                          border: "1px solid #0074D9",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={() => {
                          updatePropertyBill(billDetails, item);
                        }}
                      >
                        Update
                      </Badge>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export const ViewExpenseTableHR = ({ data, getPropertyExpense }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;

  const ApproveRejectLeave = async (expId, action) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        exp_id: expId,
        approved_byhr: action === "approve" ? "A" : "R",
        approved_byadmin: action === "approve" ? "P" : "R",
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/ApproveRejectExpense`,
        requestOptions,
      );

      const responseData = await res.json();
      if (responseData.status === "0") {
        swal("Success", responseData.msg, "success");
        getPropertyExpense();
      } else {
        swal("Error", responseData.msg, "error");
        getPropertyExpense();
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  return (
    <>
      <div className=" m-0 ">
        <div className="row">
          <div className="col-12">
            <div
              className="table-responsive"
              style={{ borderRadius: ".4em", border: "1px solid lightgrey" }}
            >
              <table className="table table-bordered m-0 p-0 ">
                <thead>
                  <tr style={{ borderBottom: "1px solid lightgrey" }}>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      ID
                    </th>

                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Name
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Type
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Date
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Amount
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Description
                    </th>

                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Approve(HR)
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Approve(Admin)
                    </th>

                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Action
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Receipt
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr
                        style={{ borderBottom: "1px solid lightgrey" }}
                        key={index}
                      >
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.pk_expense_id}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.fullname}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.expense_type}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {new Date(item.expense_date).toLocaleDateString()}
                        </td>

                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {twoDecimalPlaces(item.expense_amount)}
                        </td>

                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.description}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.approved_by_hr === "R" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 46, 46, 0.1)",
                                color: "#ff2e2e",
                                border: "1px solid #ff2e2e",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Rejected
                            </span>
                          )}
                          {item.approved_by_hr === "P" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 255, 0, 0.1)",
                                color: " #f7b12a",
                                border: "1px solid #f7b12a",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Pending
                            </span>
                          )}
                          {item.approved_by_hr === "A" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(43, 193, 85, 0.1)",
                                color: "#2bc155",
                                border: "1px solid #2bc155",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Approved
                            </span>
                          )}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.approved_by_admin === "R" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 46, 46, 0.1)",
                                color: "#ff2e2e",
                                border: "1px solid #ff2e2e",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Rejected
                            </span>
                          )}
                          {item.approved_by_admin === "P" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 255, 0, 0.1)",
                                color: " #f7b12a",
                                border: "1px solid #f7b12a",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Pending
                            </span>
                          )}
                          {item.approved_by_admin === "A" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(43, 193, 85, 0.1)",
                                color: "#2bc155",
                                border: "1px solid #2bc155",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Approved
                            </span>
                          )}
                        </td>

                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          {item.approved_by_hr === "P" ||
                          item.approved_by_admin === "P" ? (
                            <div className="d-flex justify-content-around align-items-center">
                              <button
                                type="button"
                                className="btn btn-sm btn-success d-flex justify-content-center align-items-center me-1"
                                style={{
                                  height: "2rem",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                                onClick={() =>
                                  ApproveRejectLeave(
                                    item.pk_expense_id,
                                    "approve",
                                  )
                                }
                              >
                                Approve
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger d-flex justify-content-center align-items-center"
                                style={{
                                  height: "2rem",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                }}
                                onClick={
                                  () =>
                                    ApproveRejectLeave(
                                      item.pk_expense_id,
                                      "reject",
                                    ) // Pass "reject" as action
                                }
                              >
                                Reject
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-around align-items-center">
                              <button
                                type="button"
                                className="btn btn-sm btn-success d-flex justify-content-center align-items-center"
                                style={{
                                  height: "1.5rem",
                                  borderRadius: ".3rem",
                                  fontSize: ".8rem",
                                  filter: "grayscale(100%)",
                                }}
                                disabled
                              >
                                Approve
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger d-flex justify-content-center align-items-center"
                                style={{
                                  height: "1.5rem",
                                  borderRadius: ".3rem",
                                  filter: "grayscale(100%)",
                                  fontSize: ".8rem",
                                }}
                                disabled
                              >
                                Reject
                              </button>
                            </div>
                          )}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none" }}
                        >
                          <a
                            href={item.baseurl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CiReceipt style={{ fontSize: "2rem" }} />
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
